import { createAsyncThunk } from '@reduxjs/toolkit';
import { OtpLogin } from '../../../client/services';
import { CreateWhatsappLogin } from './interface';
import { toastHandler } from '../../../utils/toastHandler';

export const createWhatsappLogin = createAsyncThunk(
  'whatsappLogin/createWhatsappLogin', async (values: CreateWhatsappLogin, { rejectWithValue }) => {
    try {
      const response = await OtpLogin.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  });
